<template>
  <transition name="fade">
    <div
      v-if="props.show"
      class="select-auto"
    >
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-10"
        @click="modalStore.toggleModal(ModalType.Share)"
      />
      <div class="absolute inset-0 w-screen h-screen flex items-center justify-center">
        <div
          class="min-w-80 max-w-4xl mx-2 p-4 relative xl:mx-auto my-auto shadow-lg bg-white z-10"
        >
          <div class="w-[600px]">
            <div class="text-center">
              <h2 class="text-3xl font-bold text-black">Share Design</h2>
              <div class="relative w-full">
                <input
                  ref="shareLinkRef"
                  class="block w-full border border-black p-2 select-text relative"
                  type="text"
                  :value="shareLink"
                  aria-label="Share design link"
                >
                <button
                  aria-label="Copy share link"
                  class="absolute right-0 top-0 size-10 text-lg py-2 px-2 text-center text-black cursor-pointer"
                  @click="copyShareLink"
                >
                  <i class="fal fa-copy" />
                </button>
              </div>
              <div class="relative w-full text-sm mt-2 mb-4">
                Copy this URL to share your awesome design!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { SweetAlertIcon } from '~/types/sweetalert'
import { ModalType } from "~/stores/modal"

const { $toast } = useNuxtApp()

const modalStore = useModalStore();
const projectStore = useProjectStore()
const runtimeConfig = useRuntimeConfig();

const shareLinkInput = useTemplateRef('shareLinkRef')
const shareLink = computed(() => {
  return `${runtimeConfig.public.studioUrl}/?import=${projectStore.designId}`
})

const copyShareLink = () => {
  shareLinkInput.value.select()
  shareLinkInput.value.setSelectionRange(0, 9999)
  navigator.clipboard.writeText(shareLinkInput.value.value)

  $toast.fire({
    text: ' Copied!',
    icon: SweetAlertIcon.SUCCESS,
  })
}

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
